export default class OrganizationCU {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async getOrganizationCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + orgID + '/cu/' + cuID;
    return await req.exec();
  }
  async removeOrganizationCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + orgID + '/cu/' + cuID;
    return await req.exec();
  }
  async createOrganizationCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organization/' + orgID + '/cu/' + cuID;
    return await req.exec();
  }
  async updateOrganizationCU(orgID, cuID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/organization/' + orgID + '/cu/' + cuID;
    return await req.exec();
  }
  /* List */
  async getAllOrganizationCUs(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/organization/${orgID}/cus`;
    return await req.exec();
  }
}
